import React from 'react';
import { MultiStepForm } from './components/MultiStepForm';
export function App() {
  return <MultiStepForm data-id="element-0" />;
}